import Image1 from "../../assets/work3.jpg"
import Image2 from "../../assets/cabinet-paiting.jpg"
import Image3 from "../../assets/wallpaper-removal.jpg"
import Image4 from "../../assets/work6.jpg"
import Image5 from "../../assets/build-paiting.jpg"
import Image6 from "../../assets/work2.jpg"
import Image7 from "../../assets/house-pressure-washing.jpg"
import Image8 from "../../assets/roof-pressure-washing-hd.jpeg"
import Image9 from "../../assets/concrete-pressure-washing.jpg"

export const Data = [
    {
      id: 1,
      image: Image1,
      title: "Wall paiting",
      description:
        "Descripcion 1.",
    },
    {
      id: 2,
      image: Image2,
      title: "Cabinet paiting",
      description:
        "Descripcion 2.",
    },
    {
      id: 3,
      image: Image3,
      title: "Wallpaper removal",
      description:
        "Descripcion 3.",
    },
    {
      id: 4,
      image: Image4,
      title: "House paiting",
      description:
        "Descripcion 4.",
    },
    {
      id: 5,
      image: Image5,
      title: "Building paiting",
      description:
        "Descripcion 4.",
    },
    {
      id: 6,
      image: Image6,
      title: "Fences",
      description:
        "Descripcion 4.",
    },
    {
      id: 7,
      image: Image7,
      title: "House wash",
      description:
        "Descripcion 4.",
    },
    {
      id: 8,
      image: Image8,
      title: "Roof wash",
      description:
        "Descripcion 4.",
    },
    {
      id: 9,
      image: Image9,
      title: "Concrete wash",
      description:
        "Descripcion 4.",
    },

  ];
  